import React from 'react'
import { Video } from '@/types/video'
import { AspectRatio } from '@chakra-ui/react'

export const VideoEmbed = (props: { data: Video }) => {
  return (
    <AspectRatio ratio={16 / 9} backgroundColor='gray.200'>
      <div>
        {props.data?.embedURL && (
          <iframe
            width='100%'
            height='100%'
            src={props.data.embedURL}
            title={props.data.title}
            allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture'
            allowFullScreen></iframe>
        )}
      </div>
    </AspectRatio>
  )
}
